import {
    FORMDESIGNER_DELETE_FORM
} from '~/frontend/src/constants';
import {
    StoreState,
    AppDispatch,
    Thunk
} from '~/frontend/src/store';

import {
    DeleteFormParameters,
    DeleteFormResult
} from '~/shared/src/utilities/modules/form';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';
import xhr from '~/frontend/src/utilities/xhr';


/**
 * @memberOf! Actions
 *
 * @param {string} panelKey
 * @param {number} formId
 * @param {( responseData : DeleteFormResult ) => void} [successCallback]
 *
 * @return {Promise<DeleteFormResult | false>}
 */
const deleteForm = ( panelKey : string, formId : number, successCallback? : ( responseData : DeleteFormResult ) => void ) : Thunk<Promise<DeleteFormResult | false>> => async ( dispatch : AppDispatch, getState : () => StoreState ) : Promise<DeleteFormResult | false> => {
    dispatch( {
        type: FORMDESIGNER_DELETE_FORM,
        panelKey,
        formId
    } );

    let retVal : DeleteFormResult | false = false;

    dispatch( clearElusiveData( panelKey ) );

    const params : DeleteFormParameters = {
              viewId: formId
          },
          response                                  = await xhr.post(
              `${BASE_URL}/api/form/deleteForm`,
              params,
              undefined,
              panelKey,
              'deleteForm',
              dispatch
          );

    if ( response?.data.success && !response.data.errorTitle ) {
        if ( successCallback ) {
            successCallback( response.data as DeleteFormResult );
        }

        retVal = response.data as DeleteFormResult;
    }

    return retVal;
};
export type DeleteForm = typeof deleteForm;

export default deleteForm;
